import serviceController from "../../../controllers/serviceController/controller";
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';
export default {
    name: 'SimpleTable',
    data() {
        return {
            company: '',
            serviceList: [],
            currentPage: 1,
            pageSize: 10,
            totalServices: 0,
            totalPages: 0,
            allIcons: [],
            dropdownOpen: false,
            icons: [],
            searchQuery: '',
            service: {
                name_service : '',
                deskripsi : '',
                created_by: '',
                created_by_name : '',
                icon: '',
                language: '',
                status : '',
            },
            selectedService: {
                updated_by: '',
                updated_by_name: '',
                updated_on: '',
            }
        };
    },
    computed : {
        filteredServices(){
            return this.serviceList.filter(service => service.name_service.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
        pages () {
            return Math.ceil(this.totalServices / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods: {
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.service.created_by = id;
            this.selectedService.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.service.created_by_name = name;
            this.selectedService.updated_by_name = name;
        },
        showModal(type, id) {
            const service = this.serviceList.find(service => service.id === id);
            this.user();
            if (service) {
                this.service = service;
                
                const modal = document.getElementById(type === 'edit' ? 'editService' : 'detailService');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
            const modalIds = ['tambahService', 'editService', 'detailService'];
            modalIds.forEach(id => {
              const modal = document.getElementById(id);
              if (modal && modal.classList.contains('show')) {
                modal.classList.remove('show');
                setTimeout(() => {
                  modal.style.display = 'none';
                }, 300);
              }
            });
          
            // Hapus backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
              backdrop.classList.remove('show');
              setTimeout(() => {
                if (backdrop.parentNode) {
                  backdrop.parentNode.removeChild(backdrop);
                }
              }, 300);
            });
          
            // Hapus kelas atau atribut yang mengunci scroll pada body
            const body = document.body;
            body.classList.remove('modal-open');
            body.style.overflow = ''; // Menghapus properti overflow jika ada
            this.fetchServices();
            this.resetForm();
        },  
        resetForm() {
            this.service.name_service = '';
            this.service.deskripsi = '';
            this.service.status = '';
            this.service.icon = '';
            this.service.language = '';
            this.iconSearch = '';
            this.icon();
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchServices();
            }
        },
        async fetchServices() {
            try {
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await serviceController.fetchServices(query, this.currentPage, this.pageSize, company);
                this.serviceList = response.data;
                this.totalAllServices();
            } catch (error) {
                console.error('Error fetching services:', error);
                throw error;
            }
        },

        async totalAllServices() {
            try {
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await serviceController.totalAllServices(query, company);
                this.totalServices = response.data;
            } catch (error) {
                console.error('Error fetching services:', error);
                throw error;
            }
        },

        async addService() {
            try {
                const name = this.service.name_service;
                const description = this.service.deskripsi;
                const icon = this.service.icon;
                const language = this.service.language;
                const is_active = this.service.status;
                const id_company = this.company;
                const created_by = this.service.created_by;
                const created_by_name = this.service.created_by_name;
                if (!name || !description || !icon || !language || !created_by || !created_by_name || !is_active) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        text: 'Isi semua field!!',
                        time: 1500
                    })
                }
                const now = new Date();
                this.service.created_on = now.toISOString().slice(0, 19).replace('T', ' ');
                const add = {
                    name : name,
                    description : description,
                    icon : icon,
                    language : language,
                    is_active : is_active,
                    id_company : id_company,
                    created_by : created_by,
                    created_by_name : created_by_name,
                    created_on : this.service.created_on
                }
                const response = await serviceController.addService(add);
                if (response.status == 200) {
                    this.closeModal();
                    this.resetForm();
                    this.fetchServices();
                    this.totalAllServices();
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil menambahkan data',
                        time: 1500
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        time: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal menambahkan data',
                    text: error.message,
                    time: 1500
                })
            }
        },

        async updateService() {
            try {
                const id = this.service.id;
                const name = this.service.name_service;
                const description = this.service.deskripsi;
                const icon = this.service.icon;
                const language = this.service.language;
                const is_active = this.service.status;
                const updated_by = this.selectedService.updated_by;
                const updated_by_name = this.selectedService.updated_by_name;
                if (!name || !description || !icon || !language || !updated_by || !updated_by_name || !is_active) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        text: 'Isi semua field!!',
                        time: 1500
                    })
                }
                const now = new Date();
                const date = now.toISOString().slice(0, 19).replace('T', ' ');
                const update ={
                    id : id,
                    name : name,
                    description : description,
                    icon : icon,
                    language : language,    
                    is_active : is_active,
                    updated_by : updated_by,
                    updated_by_name : updated_by_name,
                    updated_on : date
                }
                const response = await serviceController.updateService(update);
                if (response.status == 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Layanan berhasil diubah',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.closeModal();
                    this.fetchServices();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal mengubah data',
                        time: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal mengubah data',
                    text: error.message,
                    time: 1500
                })
            }
        },
        async deleteService(id) {
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(result => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    await serviceController.deleteService(id);
                    Swal.fire({
                        icon: 'success',
                        title: 'Layanan berhasil dihapus',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.fetchServices();
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menghapus data',
                        text: error.message,
                        time: 1500
                    })
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        },
        async icon(){
            const res = await fetch('https://raw.githubusercontent.com/twbs/icons/main/font/bootstrap-icons.json');
            const data = await res.json();
            this.allIcons = Object.keys(data).map(name => `bi bi-${name}`);
            this.icons = this.allIcons;
        },
        selectIcon(icon) {
            this.service.icon = icon;
            this.dropdownOpen = false;
        },
        searchIcon() {
            const keyword = this.iconSearch.toLowerCase();
            this.icons = this.allIcons.filter(icon =>
                icon.toLowerCase().includes(keyword)
            );
        }
    },
    mounted(){
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
        this.icon();
        this.icons = this.allIcons; 
    },
    watch: {
        searchQuery: {
            handler: 'fetchServices',
        },
        company: {
            handler: 'fetchServices'
        }
    },
    created() {
        this.icons = this.allIcons; // Awal: tampilkan semua
    },
}